import { render, staticRenderFns } from "./utility-import.vue?vue&type=template&id=5b129545"
import script from "./utility-import.vue?vue&type=script&lang=js"
export * from "./utility-import.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports